export default class StaticBlog {
  constructor(section) {
    this.el = section.el;
  }
}
